import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { environment } from '../environments/environment';
import { PureTeam } from '../utils/teamOwnership';
import { noOrgGuard } from './guards/no-org-guard';

const routes: Routes = [
    {
        // Root route redirect (eg when navigating to "pure1.purestorage.com")
        // The hasPermissionGuard will redirect again if the user doesn't have access to the /fleet page
        path: '',
        pathMatch: 'full',
        redirectTo: 'fleet',
    },
    {
        // Marketplace (flow initiated in AWS / Azure marketplaces)
        path: 'marketplace',
        loadChildren: () => import('../marketplace/marketplace.module').then(mod => mod.MarketplaceModule),
        data: {
            orgScoped: false,
        },
    },
    {
        // Unsubscribe (flow initiated in emails)
        path: 'unsubscribe-notifications',
        loadChildren: () => import('../unsubscribe/unsubscribe.module').then(mod => mod.UnsubscribeModule),
        data: {
            ownedBy: PureTeam.DX_NOTIFICATIONS,
            orgScoped: false,
        },
    },
    {
        // Customer PO Upload (unauthenticated page for customers to upload purchase orders)
        path: 'purchase-order-upload',
        loadComponent: () =>
            import('../purchase-order-upload/purchase-order-upload/purchase-order-upload.component').then(
                mod => mod.PurchaseOrderUploadComponent,
            ),
        data: {
            ownedBy: PureTeam.DX_SUBMERCE,
            orgScoped: false,
        },
    },
    {
        path: 'errors',
        loadChildren: () => import('../error/error.module').then(mod => mod.ErrorModule),
        data: {
            orgScoped: false,
        },
    },
    {
        path: 'no-role',
        loadComponent: () => import('../no-role/no-role.component').then(mod => mod.NoRoleComponent),
        canActivate: [noOrgGuard],
        data: {
            orgScoped: false,
        },
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            useHash: false,
            preloadingStrategy: environment.preloadStrategy,
        }),
    ],
    exports: [RouterModule],
})
export class RootAppRoutesModule {}
